import { II18nTimeFormatters } from "../i18n/II18nTimeFormatters";

export type I18nLocaleDataT = {
  messages: Record<string, string>;
  locale: SupportedLanguageCodeT;
  timeFormatters: II18nTimeFormatters;
};

export const SUPPORTED_LANGUAGE_CODES = [
  "en",
  "zh-CN",
  "zh-TW",
  "fr",
  "de",
  "it",
  "ja",
  "ko",
  "pt-BR",
  "ru",
  "es",
  "he",
  "ar",
  "cs",
  "da",
  "hu",
  "id",
  "no",
  "nl",
  "pl",
  "ro",
  "sk",
  "sv",
  "th",
  "tr",
  "uk",
] as const;
//#endregion

export type SupportedLanguageCodeT = (typeof SUPPORTED_LANGUAGE_CODES)[number];

export type I18nLocaleLoaderLoadLanguageMessagesOptionsT = {
  languageCode: SupportedLanguageCodeT;
  setAsDefault: boolean;
};
